import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export default function IntroEditor({ introHtml, onChange }) {
  const editor = useEditor({
    extensions: [StarterKit],
    content: introHtml || "",
    onUpdate: ({ editor }) => onChange(editor.getHTML()),
  });

  return (
    <fieldset style={{ marginBottom: 24 }}>
      <legend><strong>Introduction</strong></legend>
      <div style={{ minHeight: 100, border: "1px solid #ddd", borderRadius: 4, padding: 8 }}>
        <EditorContent editor={editor} />
      </div>
    </fieldset>
  );
}
